// @flow
import * as React from 'react';
import Box from "@mui/material/Box";
import {Popover} from "@mui/material";
import RegistrationInfo from "../registrationInfo/registrationInfo";
import AgreeToTerms from "./agreeToTerms";

type Props = {

};

const AgreeToTermsPopOver = ({agreeToTermsPopOver, handleAgreeToTermsPopOver}: Props) => {
    const handlePopOverClose = () => {
        handleAgreeToTermsPopOver({anchorEl: null, open: false, body: ''})
    }

    return (
        <React.Fragment>
            <Box onClick={(e) => e.stopPropagation()}>
                <Popover
                    disableRestoreFocus
                    onClose={handlePopOverClose}
                    open={agreeToTermsPopOver.open}
                    anchorEl={agreeToTermsPopOver.anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    sx={{maxWidth: '90%'}}
                >
                    <Box sx={{width: '100%', padding: '20px'}}>
                        <AgreeToTerms />
                    </Box>
                </Popover>
            </Box>
        </React.Fragment>
    );
};

export default AgreeToTermsPopOver